export default "__VITE_ASSET__Bf9VKw0I__"